import React, { FunctionComponent } from 'react';
import {
  SubHeader,
  SubHeaderTitle,
  SubHeaderMenu,
} from '@app/shop/components/Skeleton/Skeleton';

const PricingPageHeader: FunctionComponent<PricingPageHeaderProps> = ({
  title,
  bgColor,
  links,
}) => (
  <SubHeader bgColor={bgColor}>
    <SubHeaderTitle data-testid="pricing-header-title">{title}</SubHeaderTitle>

    <SubHeaderMenu>
      {links?.map(
        (link, index) =>
          link?.title &&
          link?.url && (
            <a
              key={index}
              href={link?.url}
              data-testid={`pricing-subheader-link-${index}`}
            >
              {link?.title}
            </a>
          )
      )}
    </SubHeaderMenu>
  </SubHeader>
);
interface PricingPageHeaderProps {
  title: string | null;
  bgColor: string | null;
  links?: ({ title: string; url: string } | null)[];
}

export default PricingPageHeader;
